
import { Component, Vue } from 'vue-property-decorator';
import { DATA } from '@/config/data';
import authService from '@/services/auth-services';
import { Customer } from '@/models/customer';
import Loading from 'vue-loading-overlay';
import commonService from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';


@Component({
    components: {
        Loading,
    },
})
export default class Register extends Vue {
    private isLoading = false;
    private firstName = '';
    private lastName = '';
    private phoneNumber = '';
    private email = '';
    private userName = '';
    private address = '';
    private password = '';
    private rePassword = '';
    private selectedStoreArea = 1;
    private selectedChinaStore = 1;

    constructor() {
        super();
    }

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    get chinaStore() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore;
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
        }
    }

    private async created() {
        if (!this.warehouse) {
            await this.getWarehouse();
            if(this.warehouse.length > 0) {
                this.selectedStoreArea = this.warehouse[0].ID;
            }
        }
        if (!this.chinaStore) {
            await this.getChinaStore();
            if(this.chinaStore.length > 0) {
                this.selectedChinaStore = this.chinaStore[0].ID;
            }
        }
    }

    private async submit() {
        const isValid = await (this.$refs['observer'] as any).validate();

        if (isValid) {
            this.isLoading = true;
            const dataRequest: Customer = {
                UserName: this.userName.toLowerCase(),
                Email: this.email,
                FirstName: this.firstName,
                LastName: this.lastName,
                PhoneNumber: this.phoneNumber,
                Password: this.password,
                ReceivePlaceID: this.selectedStoreArea,
                ChinaStoreID: this.selectedChinaStore,
                Address: this.address
            };
            const result  = await authService.register(dataRequest);
            this.isLoading = false;
            if (result && result.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Bạn đã đăng ký thành công!',
                });
                (window['getApp'] as any).$emit('APP_REGISTER_SUCCESS');
            } else if (result && result.data.status === 202) {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: result.data.error,
                });
            } else {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'Có lỗi trong quá trình xử lý dữ liệu!',
                });
            }
        }
    }
}
